import { defineComponent as _defineComponent } from 'vue'
import { useBabelfish } from '@/comp/use-babelfish';
import { computed, ref, watch, withDefaults } from 'vue';
import { TranslationGroup, SourceType } from '@ilteducation/babelfish-types';
import axios from 'axios';
type Props = {
  id: string;
  sourceType: SourceType;
  pathOrder?: string[];
  visibleLanguages?: string[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'TranslationsTable',
  props: {
    id: null,
    sourceType: null,
    pathOrder: null,
    visibleLanguages: { default: () => ['sv', 'en-gb'] }
  },
  setup(__props: any, { expose }) {

const props = __props as { id: string, sourceType: SourceType, pathOrder?: string[], visibleLanguages: string[] }

const { orderedLanguages } = useBabelfish();



const translationGroups = ref<TranslationGroup[]>();
const hasTranslations = computed(() => {
  return translationGroups.value?.length ?? 0 > 0;
});
const showAll = ref<{ [sourcePath: string]: boolean }>({});

watch(
  () => props.id,
  () => {
    axios.get(`${process.env.VUE_APP_TRANSLATIONS_API_URL}/${props.id}`).then((response) => {
      translationGroups.value = response.data;
      if (props.pathOrder) {
        translationGroups.value?.sort((a, b) => {
          const aIndex = props.pathOrder!.indexOf(a.sourcePath);
          const bIndex = props.pathOrder!.indexOf(b.sourcePath);
          return aIndex - bIndex;
        });
      }
      showAll.value =
        translationGroups.value?.reduce((acc, tg) => {
          acc[tg.sourcePath] = false; // Hide translations by default
          return acc;
        }, {} as { [sourcePath: string]: boolean }) ?? {};
    });
  },
  { immediate: true },
);

const languages = computed(() => orderedLanguages(props.sourceType));
expose({
  hasTranslations,
});

return { __sfc: true,orderedLanguages, props, translationGroups, hasTranslations, showAll, languages }
}

})